import $ from 'jquery';

function lookupPostalCode(postalCode, postalDistrict) {
    if (postalCode.val()) {
        fetch(`/get-postal-district?postalCode=${postalCode.val()}`, {credentials: 'same-origin'})
            .then(response => {
                if (!response.ok) {
                    throw new Error();
                }
                return response;
            })
            .then(response => response.json())
            .then(json => postalDistrict.val(json.postalDistrict))
            .catch(() => postalDistrict.val(''));
    }
    else {
        postalDistrict.val('');
    }
}

function addPostalCodeLookup(postalCode, postalDistrict) {
    lookupPostalCode(postalCode, postalDistrict);
    postalCode.on('change', function () {
        lookupPostalCode(postalCode, postalDistrict);
    })
}

$(() => {
    addPostalCodeLookup($('#fromPostalCode'), $('#fromPostalDistrict'));
    addPostalCodeLookup($('#toPostalCode'), $('#toPostalDistrict'));
});
